import create from "zustand";

const useSocketDataStore = create((set: any) => ({
    socketCallStatus: {},
    setSocketCallStatus: (data: any) => set(() => ({ socketCallStatus: data })),
    socketCallQueue: [],
    setSocketCallQueue: (data: any) => set(() => ({ socketCallQueue: data })),
    bhvmTickets: [],
    setBhvmTickets: (data: any) => set(() => ({ bhvmTickets: data })),
}));

export { useSocketDataStore };
